import { apiClient } from '@/config/api';
import { Device, HydraCollection } from '@/types';

export const deviceService = {
  // Get devices by box
  async getDevicesByBox(boxId: number): Promise<Device[]> {
    const response = await apiClient.get<HydraCollection<Device>>('/devices', {
      params: {
        'box': `/api/boxes/${boxId}`,
      },
    });

    const data = response.data;
    const devices = data['hydra:member'] || data['member'] || [];
    return devices;
  },

  // Get device with attributes (lazy loading)
  async getDeviceWithAttributes(deviceId: number): Promise<Device> {
    const response = await apiClient.get<Device>(`/devices/${deviceId}`, {
      params: {
        'groups[]': ['device:read', 'attribute:read'],
      },
    });
    return response.data;
  },

  // Get single device by ID
  async getDevice(id: number): Promise<Device> {
    const response = await apiClient.get<Device>(`/devices/${id}`);
    return response.data;
  },

  // Create device
  async createDevice(data: Partial<Device>): Promise<Device> {
    const response = await apiClient.post('/devices', data);
    return response.data;
  },

  // Update device
  async updateDevice(id: number, data: Partial<Device>): Promise<Device> {
    const response = await apiClient.put(`/devices/${id}`, data);
    return response.data;
  },

  // Delete device
  async deleteDevice(id: number): Promise<void> {
    await apiClient.delete(`/devices/${id}`);
  },

  // Associate device with area
  async associateDeviceWithArea(deviceId: number, areaId: number): Promise<void> {
    await apiClient.post(`/devices/${deviceId}/areas/${areaId}`);
  },

  // Disassociate device from area
  async disassociateDeviceFromArea(deviceId: number, areaId: number): Promise<void> {
    await apiClient.delete(`/devices/${deviceId}/areas/${areaId}`);
  },
};
